if (!customElements.get('popup-content')) {
  class PopupContent extends HTMLElement {
    constructor() {
      super();

      this.handleToggleRef = this.handleToggle.bind(this);
    }

    playVideo() {
      this.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage(
          '{"event":"command","func":"' + 'playVideo' + '","args":""}',
          '*',
        );
      });

      this.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"play"}', '*');
      });
    }

    handleToggle(event) {
      if (this.getAttribute('data-id') != event.detail.id) return;

      this.classList.toggle('is-open');
      toggleLock(this.classList.contains('is-open'), this);

      window.pauseAllMedia();
      if (this.classList.contains('is-open')) this.playVideo();
    }

    disconnectedCallback() {
      document.removeEventListener('exo:popup-toggle', this.handleToggleRef);
    }

    connectedCallback() {
      document.addEventListener('exo:popup-toggle', this.handleToggleRef);
    }
  }

  customElements.define('popup-content', PopupContent);
}
